export default __webpack_public_path__ + "static/button-label-dont-dark-b5f6f7e92959cf977c7428d8b3b6d3f7.png";